// extracted by mini-css-extract-plugin
export default {"container":"propertiesContainer_container__RP8g+","containerRow":"propertiesContainer_containerRow__YgL6z"};